"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portfolioLoanSchema = void 0;
var borrower_schema_1 = require("./borrower-schema");
var credit_check_schema_1 = require("./credit-check-schema");
var credit_check_text_schema_1 = require("./credit-check-text-schema");
var decision_schema_1 = require("./decision-schema");
var mortgage_ranking_schema_1 = require("./mortgage-ranking-schema");
var price_schema_1 = require("./price-schema");
var property_schema_1 = require("./property-schema");
var risk_result_schema_1 = require("./risk-result-schema");
var reamortized_loan_schema_1 = require("./reamortized-loan-schema");
exports.portfolioLoanSchema = {
    type: 'object',
    required: [
        'cmhcAccountNumber',
        'accountStatusTypeCode',
        'applicationReceivedDate',
        'canadaPostStandardProvinceSymbol',
        'cmhcFeesDueAmount',
        'energyEfficientIndicator',
        'feeProvincialSalesTaxPayableAmount',
        'firstMortgageInsuranceLocationCode',
        'indemnifiedIndicator',
        'interestTypeCode',
        'lenderLoanAmount',
        'lenderLoanNumber',
        'loanInterestRate',
        'loanTermPeriod',
        'loanToValueRatioPercent',
        'loanTypeCode',
        'lowRatioAgeRangeTypeCode',
        'lowRatioInsurableIndicator',
        'mliPremiumDueAmount',
        'originalLoanPrincipalAmount',
        'productTrackerID',
        'propertyMarketValueAmount',
        'provincialSalesTaxDueAmount',
        'poolCmhcAccountNumber',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'reducedDatasetProvidedIndicator',
        'remainingAmortizationPeriod',
        'riskResultOverrideIndicator',
        'statisticsCanadaProvinceID',
        'urbanPremiumIndicator',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be an integer between 0 and 999999999999',
        },
        portfolioID: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        accountStatusTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        applicationApprovedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationCancelledDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationReceivedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
        applicationReinstatementDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        applicationRejectedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        canadaPostStandardProvinceSymbol: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        cmhcFeesDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        currentFirstMortgageOutstandingAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision or null',
        },
        currentPropertyAppraisedValueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision or null',
        },
        energyEfficientIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        feeProvincialSalesTaxPayableAmount: {
            type: 'number',
            maximum: 999999999,
            minimum: -999999999,
            decimal: [11, 2],
            errorMessage: 'should be a decimal with up to 11 digits in total and up to 2 digits of precision',
        },
        firstMortgageCmhcAccountNumber: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        firstMortgageInsuranceLocationCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        firstMortgageOutstandingAmountAtSecondMortgage: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision or null',
        },
        indemnifiedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        interestAdjustmentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        interestTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lastPrivateSecuritizationDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        lastStatusUpdateTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000 or null',
        },
        lenderLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        lenderLoanNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        loanInterestRate: {
            type: 'number',
            maximum: 99,
            minimum: -99,
            decimal: [6, 4],
            errorMessage: 'should be a decimal with up to 6 digits in total and 4 digits of precision',
        },
        loanTermExpiryDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        loanTermPeriod: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        loanToValueRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            decimal: [5, 2],
            errorMessage: 'should be a decimal with up to 5 digits in total and 2 digits of precision',
        },
        loanTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lowRatioAgeRangeTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lowRatioFinalPriceEstimateAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision or null',
        },
        lowRatioInsurableIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        mliPremiumDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        multipleComponentText: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 50,
            errorMessage: 'should have variable length up to 50 characters or null',
        },
        originalLoanPrincipalAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        parentExposureID: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        poolCmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        productTrackerID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        propertyMarketValueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        provincialSalesTaxDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        reducedDatasetProvidedIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        remainingAmortizationPeriod: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        riskResultOverrideIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        statisticsCanadaProvinceID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        urbanPremiumIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        property: property_schema_1.propertySchema,
        borrowers: {
            type: ['array', 'null'],
            items: borrower_schema_1.borrowerSchema,
        },
        creditChecks: {
            type: ['array', 'null'],
            items: credit_check_schema_1.creditCheckSchema,
        },
        creditChecksText: {
            type: ['array', 'null'],
            items: credit_check_text_schema_1.creditCheckTextSchema,
        },
        riskResult: risk_result_schema_1.riskResultSchema,
        mortgageRanking: mortgage_ranking_schema_1.mortgageRankingSchema,
        reamortizedLoan: reamortized_loan_schema_1.reamortizedLoanSchema,
        decisionOutput: decision_schema_1.decisionOutputSchema,
        priceOutput: price_schema_1.priceOutputSchema,
    },
};
exports.default = exports.portfolioLoanSchema;
